import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", async function () {
    "use strict";

    const sliderElement = document.querySelector(".tileslider .swiper");

    // Guard clause: Exit early if the slider element isn't present
    if (!sliderElement) return;

    // 1. Safe Event Delegation for Clicks (Attaching immediately)
    sliderElement.addEventListener("click", function (event) {
        const tile = event.target.closest('.tile[data-clicktarget]');
        if (tile) {
            const url = tile.getAttribute("data-clicktarget");
            if (url) window.location.href = url;
        }
    });

    try {
        // 2. Dynamically import Swiper bundle only when element exists
        const { default: Swiper, Pagination } = await import('swiper/bundle');

        // 3. Initialize Swiper
        const swiper = new Swiper(sliderElement, {
            modules: [Pagination],
            loop: true,
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 20,
            autoplay: false,
            speed: 800,
            slideToClickedSlide: true,

            pagination: {
                el: sliderElement.querySelector('.swiper-pagination') || '.swiper-pagination',
                clickable: true,
                dynamicBullets: false
            },

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 15,
                    slidesOffsetBefore: 30,
                    slidesOffsetAfter: 30
                },
                520: {
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 15,
                    slidesOffsetBefore: 60,
                    slidesOffsetAfter: 60
                },
                768: {
                    slidesPerView: 2,
                    centeredSlides: false,
                    spaceBetween: 20,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
            }
        });
    } catch (error) {
        console.error("Failed to load or initialize Swiper module:", error);
    }
});